$(document).ready(function() {
  $('br').attr('aria-hidden','true');
  $('.h5.tab_a').attr('role', 'tab');
  $('.h5.hide').attr('role', 'tab');
  // for related product slider
  setTimeout(function() {
    $('.col-span-1.splide__slide.col_item[role="tabpanel"]').removeAttr('role');

  }, 2000);

  setInterval(() => {
    $('.splide__pagination__page').attr('aria-selected','false');
    $('.splide__pagination__page.is-active').attr('aria-selected','true');
    $('.collection_tab_slider.active').removeAttr('aria-hidden','true');
    $('.splide__slide ').removeAttr('role','tabpanel');
    $('.Phone').removeAttr('aria-label');

    
  }, 1000);
   
  // Product Page heading Issue from 3rd Party
  setTimeout(function() {
    $('h3.stamped-review-header-title').replaceWith(function() {
      return $('<span>', {
        class: $(this).attr('class'), // Preserve class
        html: $(this).html()         // Keep content
      });
    });
  }, 2000); // 1000ms = 1 second delay
 

});
/// For All Phone Numbers
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const telNumber = $(this).attr('href').replace('tel:', '');
    const ariaNumber = telNumber.replace(/-/g, '.'); // Replace hyphens with dots
    $(this).attr('aria-label', `Phone Number: ${ariaNumber}`);
  });
});

// List of Email aria label assaigned
$(document).ready(function() {
  // Target ALL email links (any format)
  $('a[href^="mailto:"]').each(function() {
    // Extract email from href
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});

// Social and External link warning Fixed
$(document).ready(function() {

  const currentHost = window.location.hostname.replace(/^www\./, '');

  $('a[href^="http://"], a[href^="https://"]').each(function() {

    const $link = $(this);
    const linkHost = this.hostname.replace(/^www\./, '');

    if (!linkHost || linkHost === currentHost) return;

    if ($link.hasClass('external-link-processed')) return;

    $link.attr({
      target: '_blank',
      rel: 'noopener noreferrer'
    });

    if ($link.find('.sr-only').length === 0) {
      $link.append(' <span class="sr-only">Redirecting to a third-party website (opens in a new tab).</span>');
    }

    $link.addClass('external-link external-link-processed');

  });

});

//Empty Heading issue Fixed
$(document).ready(function() {
  // Remove all empty headings (h1-h6), including those with only <br> tags
  $('h1, h2, h3, h4, h5, h6').each(function() {
    var $heading = $(this);
    // Check if heading is empty or contains only <br> tags (with or without aria-hidden="true")
    if ($.trim($heading.text()).length === 0 && $heading.children('br').length === $heading.children().length) {
      $heading.remove();
    }
  });
});


// For Prices Regular, Sale.
$(document).ready(function () {
  $('.plp_saleprice').each(function () {
    const $salePrice = $(this);
  
    // Check for a <span> with the specific attribute
    const hasCurrencyZero = $salePrice.find('span[doubly-currency-usd="0"]').length > 0;
  
    // Set aria-hidden accordingly
    if (hasCurrencyZero) {
      $salePrice.attr('aria-hidden', 'true');
    } else {
      $salePrice.attr('aria-hidden', 'false');
    }
  });
});
  
// Product Page Tabs
$(document).ready(function() {
  // Initialize tabs
  function initializeTabs() {
    var $firstVisibleTab = $('.pdp_tabs_links a:visible').first();
    
    if ($firstVisibleTab.length) {
      activateTab($firstVisibleTab, true);
    }
  }

  // Activate tab with screen reader support
  function activateTab($tab, isInitial = false) {
    var $allTabs = $('.pdp_tabs_links a');
    var tabText = $tab.text().trim();
    
    // Remove active state from all tabs
    $allTabs.removeClass('active').attr('aria-selected', 'false');
    
    // Add active state to clicked tab
    $tab.addClass('active').attr('aria-selected', 'true');
    
    // Update tabindex for keyboard navigation
    $allTabs.attr('tabindex', '-1');
    $tab.attr('tabindex', '0');
    
    // Screen reader announcement
    if (!isInitial) {
      announceToScreenReader(tabText + ' tab selected');
    }
    
    // Show corresponding content (if you have content panels)
    showTabContent($tab);
    
    console.log('Tab activated:', tabText, isInitial ? '(initial)' : '(user action)');
  }

  // Show corresponding tab content
  function showTabContent($tab) {
    var tabId = $tab.data('tag');
    
    // Hide all tab content panels
    $('.tab-content-panel').attr('aria-hidden', 'true').removeClass('active');
    
    // Show the active tab content
    var $contentPanel = $('[data-tab-content="' + tabId + '"]');
    if ($contentPanel.length) {
      $contentPanel.attr('aria-hidden', 'false').addClass('active');
    }
  }

  // Screen reader announcement function
  function announceToScreenReader(message) {
    // Create or get aria-live region
    var $liveRegion = $('#sr-announcement');
    
    if (!$liveRegion.length) {
      $liveRegion = $('<div>', {
        id: 'sr-announcement',
        'aria-live': 'polite',
        'aria-atomic': 'true',
        class: 'sr-only'
      }).appendTo('body');
    }
    
    // Update message
    $liveRegion.text(message);
    
    // Clear message after a delay to allow repeated announcements
    setTimeout(function() {
      $liveRegion.text('');
    }, 1000);
  }

  // Keyboard navigation
  function handleKeyboardNavigation(e) {
    var $tabs = $('.pdp_tabs_links a:visible');
    var currentIndex = $tabs.index(this);
    var $currentTab = $(this);

    switch(e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        activateTab($currentTab);
        break;
        
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        var nextIndex = (currentIndex + 1) % $tabs.length;
        var $nextTab = $tabs.eq(nextIndex);
        activateTab($nextTab);
        $nextTab.focus();
        break;
        
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        var prevIndex = (currentIndex - 1 + $tabs.length) % $tabs.length;
        var $prevTab = $tabs.eq(prevIndex);
        activateTab($prevTab);
        $prevTab.focus();
        break;
        
      case 'Home':
        e.preventDefault();
        var $firstTab = $tabs.first();
        activateTab($firstTab);
        $firstTab.focus();
        break;
        
      case 'End':
        e.preventDefault();
        var $lastTab = $tabs.last();
        activateTab($lastTab);
        $lastTab.focus();
        break;
    }
  }

  // Click handler
  $('.pdp_tabs_links').on('click', 'a', function(e) {
    e.preventDefault();
    activateTab($(this));
  });

  // Keyboard handler
  $('.pdp_tabs_links').on('keydown', 'a', handleKeyboardNavigation);

  // Focus management
  $('.pdp_tabs_links a').on('focus', function() {
    var $tab = $(this);
    if (!$tab.hasClass('active')) {
      // Optional: announce tab name on focus for screen readers
      announceToScreenReader($tab.text().trim() + ' tab, ' + ($('.pdp_tabs_links a:visible').index($tab) + 1) + ' of ' + $('.pdp_tabs_links a:visible').length);
    }
  });

  // Initialize tabs
  initializeTabs();
});

// Add CSS for screen reader only class
if (!$('style:contains(".sr-only")').length) {
  $('head').append('<style>.sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }</style>');
}
// end product tab


//
$(document).ready(function () {
  $('a.Faq__Question.faq_header').on('click', function () {
    const $button = $(this);
    const expanded = $button.attr('aria-expanded') === 'true';
    $button.attr('aria-expanded', !expanded);
 
    const $content = $button.next();
    $content.prop('hidden', expanded);
  });
});

$(document).ready(function() {
  $('a.external-link .imageforlink img').each(function() {
      // Trim the alt text of the image
      var altText = $(this).attr('alt') || '';
      var trimmedAlt = altText.trim();
      $(this).attr('alt', trimmedAlt);
      
      // Get the parent anchor
      var parentAnchor = $(this).closest('a.external-link');
      
      // Set aria-label on the anchor
      var ariaLabel = trimmedAlt;
      if (ariaLabel) {
          ariaLabel += ', ';
      }
      ariaLabel += 'this link will open in a new tab';
      
      parentAnchor.attr('aria-label', ariaLabel);
      parentAnchor.removeAttr('title');
  });
});

// Function to update aria-hidden attributes
function updateAriaHidden() {
  $('.collection_tab_slider').attr('aria-hidden', 'true');
  $('.collection_tab_slider.active').removeAttr('aria-hidden');
}
updateAriaHidden();
const observer = new MutationObserver(updateAriaHidden);
$('.collection_tab_slider').each(function () {
  observer.observe(this, { attributes: true, attributeFilter: ['class'] });
});

// Home Page Tabs
$(document).ready(function() {
  // On page load, set aria-selected="false" for all tabs
  $('.collection_tab_links .tab_a').attr('aria-selected', 'false');
  
  // Set aria-selected="true" for the active tab
  $('.collection_tab_links .tab_a.active').attr('aria-selected', 'true');

  // When a tab link is clicked
  $('.collection_tab_links .tab_a').on('click', function() {
    // Remove 'active' class and set 'aria-selected' to false for all tab links
    $('.collection_tab_links .tab_a').removeClass('active').attr('aria-selected', 'false');
    
    // Add 'active' class to the clicked tab link and set 'aria-selected' to true
    $(this).addClass('active').attr('aria-selected', 'true');
  });
});

// For the Page Meet the crew

$(document).ready(function () {

    $('#cartdrawer_header button').on('click', function () {
        var $target = $('#addToCartButton');

        if ($target.length) {
            $target.attr('tabindex', '-1');
            $target.focus();
        }
    });
$('.press-text-columns-with-images-section .heading-title h2').attr('aria-level', '1');
});